import React from 'react'
import styled from 'styled-components'
import mainTranslate from 'loankeeper-common/helpers/language'
import { QuickAccessToolbar } from 'loankeeper-common/components'

import { useSystemConfig } from 'shared'
//@ts-ignore
import withAuthorized from 'shared/containers/withAuthorized'

//@ts-ignore
import { createApplicationAddNavigationItem } from 'shared/ApplicationFactory'
import { createClientAddNavigationItem } from '../ClientAdd'
import { createLoanSearchModalNavigationItem } from '../ApplicationSearchModal'
import { createCollateralFormNavigationItem } from '../CollateralForm'
import { createAccountAddNavigationItem } from '../AccountForm'
import { createAccountSearchNavigationItem } from '../AccountSearch'
import { createUserReportsNavigationItem } from '../Reporting'
import { createOrderSearchNavigationItem } from '../OrderSearch'
import { createUCCPayNavigationItem } from '../UCCPayForm'
import {
  createMemorialOrderAddNavigationItem,
  createOrderCashInAddNavigationItem,
  createOrderCashOutAddNavigationItem,
  createConvertOnAccountNavigationItem,
  createConvertOnCashboxNavigationItem,
} from '../OrderAdd'

import { useModalActions, useHistoryPush, usePermissionCheck } from './navigationHooks'

const translator = (key: string): string => mainTranslate('frm_Main', key)

const StyledQuickAccessToolbar = styled(QuickAccessToolbar)`
  .ui.button.quick-access-item {
    background: var(--color-navigation-background);

    &:hover {
      background-color: var(--color-navigation-button-background-hover);
    }
  }
`

const QuickAccessToolbarWrapper = () => {
  const { dispatch, openModal } = useModalActions()

  //@ts-ignore
  const openQuickAccessModal = React.useCallback((modalInstanceName) => openModal(modalInstanceName), [openModal])

  const pushToHistory = useHistoryPush()

  const { checkPermission } = usePermissionCheck()

  //@ts-ignore
  const { isAccountEnabled }: { isAccountEnabled: string } = useSystemConfig(['AccEnabled as isAccountEnabled'])

  const items = React.useMemo(
    () => [
      checkPermission('ADD_CLIENT') ? createClientAddNavigationItem(translator, openQuickAccessModal) : undefined,
      // TODO: refactor this after QuickAccessToolbar
      createApplicationAddNavigationItem(translator, (openApplicationAdd) => dispatch(openApplicationAdd(dispatch))),
      createLoanSearchModalNavigationItem(translator, openQuickAccessModal),
      checkPermission('ADD_COLLATERAL')
        ? createCollateralFormNavigationItem(translator, openQuickAccessModal)
        : undefined,
      ...(isAccountEnabled === '1'
        ? [
            createAccountAddNavigationItem(translator, openQuickAccessModal),
            createAccountSearchNavigationItem(translator, pushToHistory),
            createUserReportsNavigationItem(translator, pushToHistory),
            createOrderSearchNavigationItem(translator, pushToHistory),
            createMemorialOrderAddNavigationItem(translator, openQuickAccessModal),
            createOrderCashInAddNavigationItem(translator, openQuickAccessModal),
            createOrderCashOutAddNavigationItem(translator, openQuickAccessModal),
            createConvertOnAccountNavigationItem(translator, openQuickAccessModal),
            createConvertOnCashboxNavigationItem(translator, openQuickAccessModal),
            createUCCPayNavigationItem(translator, openQuickAccessModal),
          ]
        : []),
    ],
    [openQuickAccessModal, dispatch, pushToHistory, isAccountEnabled, checkPermission],
  )

  return <StyledQuickAccessToolbar items={items} checkPermission={checkPermission} />
}

export default withAuthorized(QuickAccessToolbarWrapper)
